import { SafetyLocalStorage, SafetySessionStorage } from '@mail-core/std';
import { useEffect, useRef, useState } from 'react';
import type { TTimer } from 'reactApp/hooks/useLongLoad';

export const useAutoShowTooltip = (
    featureEnabled: boolean,
    storageKey: string,
    activeTab: string | undefined,
    targetTab: string,
    delay: number = 1000
) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const autoHideTimerRef = useRef<TTimer>(null);
    const storage = new SafetySessionStorage({});
    const localStorageSafe = new SafetyLocalStorage({});
    const autoClosedKey = `${storageKey}__autoClosed`;

    useEffect(() => {
        if (featureEnabled && !storage.getItem(storageKey) && !localStorageSafe.getItem(autoClosedKey) && activeTab === targetTab) {
            const showTimer = setTimeout(() => {
                setShowTooltip(true);
                storage.setItem(storageKey, 'true');

                autoHideTimerRef.current = setTimeout(() => {
                    setShowTooltip(false);
                    // фиксируем, что тултип скрылся автоматически по истечении таймера и больше не показываем
                    localStorageSafe.setItem(autoClosedKey, 'true');
                }, 30000);
            }, delay);

            return () => {
                clearTimeout(showTimer);
                if (autoHideTimerRef.current) {
                    clearTimeout(autoHideTimerRef.current);
                }
            };
        }
    }, [activeTab, featureEnabled, storageKey, targetTab, delay]);

    useEffect(() => {
        return () => {
            if (autoHideTimerRef.current) {
                clearTimeout(autoHideTimerRef.current);
            }
        };
    }, []);

    return { showTooltip, setShowTooltip };
};
